import { ProjectCard } from '@/components/ui';
import { portfolioProjects } from '@/data/portfolio-projects';
import React from 'react';

export interface PortfolioProjectsProps {
    isMobile?: boolean;
}

export const PortfolioProjects: React.FC<PortfolioProjectsProps> = ({ isMobile = false }) => {
    // Conditional styling based on mobile/desktop
    const containerClasses = isMobile ? 'bg-vscode-bg text-vscode-text p-6' : 'bg-vscode-bg text-vscode-text p-8';

    const maxWidthClasses = isMobile ? 'max-w-4xl mx-auto' : 'max-w-7xl mx-auto';

    const headerMarginClasses = isMobile ? 'text-center mb-10' : 'text-center mb-12';

    const titleClasses = isMobile
        ? 'text-3xl font-bold text-vscode-accent mb-4'
        : 'text-4xl font-bold text-vscode-accent mb-4';

    const subtitleClasses = isMobile
        ? 'text-vscode-text-muted text-base max-w-2xl mx-auto'
        : 'text-vscode-text-muted text-lg max-w-2xl mx-auto';

    const projectsGridClasses = isMobile ? 'grid gap-6' : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8';

    return (
        <div className={containerClasses}>
            <div className={maxWidthClasses}>
                {/* Header */}
                <div className={headerMarginClasses}>
                    <h1 className={titleClasses}>Recent Work</h1>
                    <p className={subtitleClasses}>
                        A collection of projects showcasing my expertise in software development, from low-level systems
                        programming to web applications.
                    </p>
                </div>

                {/* Projects Grid */}
                <div className={projectsGridClasses}>
                    {portfolioProjects.map(project => (
                        <ProjectCard
                            key={project.id}
                            project={project}
                            className={!isMobile ? 'hover:shadow-lg flex flex-col' : ''}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
